var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"router-header flex flex-wrap items-center mb-3 mb-base"},[_c('div',{staticClass:"content-area__heading pr-4"},[_c('div',{staticClass:"mt-2 mb-1"},[_c('span',{staticStyle:{"font-size":"25px"}},[_vm._v(_vm._s(_vm.statement))])])])]),_c('div',{staticClass:"items-center"},[_c('ThreeStepToggle',{attrs:{"q":_vm.q}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }